<template>

<div @keyup.capture="updateValue">

	<div :class="{ 'three-one-columns': !addressOnly }" style="height: calc(100vh - 21em); overflow-y: scroll;">
		<div>
			<div v-if="addressOnly">
				<label>Full Name</label>
				<input :disabled="disabled" type="text" v-model="contactCopy.full_name">
			</div>
			<div v-else class="four-columns">
				<label>First Name</label>
				<label>Middle Name</label>
				<label>Last Name</label>
				<label>Suffix</label>
				<input :disabled="disabled" type="text" v-model="contactCopy.first_name">
				<input :disabled="disabled" type="text" v-model="contactCopy.middle_name">
				<input :disabled="disabled" type="text" v-model="contactCopy.last_name">
				<input :disabled="disabled" type="text" v-model="contactCopy.suffix">
			</div>
			<div v-if="!addressOnly">
				<label>Company</label>
				<input :disabled="disabled" type="text" v-model="contactCopy.company_name">
			</div>
			<label-required label="Address Line 1" :condition="addressNotRequired || contactCopy.address_1"></label-required><input :disabled="disabled" type="text" v-model="contactCopy.address_1">
			<label>Address Line 2</label><input :disabled="disabled" type="text" v-model="contactCopy.address_2">
			<div class="two-columns">
				<div>
					<label-required label="City" :condition="addressNotRequired || contactCopy.city"></label-required>
					<input :disabled="disabled" type="text" v-model="contactCopy.city">
				</div>
				<div class="two-columns">
					<label-required label="State" :condition="addressNotRequired || contactCopy.state || (contactCopy.country_code && contactCopy.country_code != 'US')"></label-required>
					<label-required :label="contactCopy.country_code && contactCopy.country_code != 'US' ? 'Postal Code' : 'Zip Code'" :condition="addressNotRequired || contactCopy.zip_code"></label-required>
					<state-select type="text" :disabled="disabled" :selectedState="contactCopy.state" :showApo="true" :showProvinces="true" placeHolder="Select..." @updateSelected="updateSelectedState"></state-select>
					<input :disabled="disabled" type="text" v-model="contactCopy.zip_code">
				</div>
			</div>
			<div class="two-columns">
				<div>
					<label-required label="Email Address" :condition="!emailRequired || contactCopy.email_address"></label-required>
					<input :disabled="disabled" type="text" v-model="contactCopy.email_address">
					<div class="two-one-columns">
						<div>
							<label>Phone Number</label>
							<input :disabled="disabled" type="text" v-model="contactCopy.phone_number">
						</div>
						<div v-if="!addressOnly">
							<label>Type</label>
							<select :disabled="disabled" v-model="contactCopy.phone_number_type_id" @change="updateValue">
								<option value="">Select...</option>
								<option v-for="(phoneNumberType, index) in getPhoneNumberTypes" :value="phoneNumberType.phone_number_type_id">{{ phoneNumberType.description }}</option>
							</select>
						</div>
					</div>
					<div v-if="!addressOnly" class="two-one-columns">
						<label>Alt Phone Number</label>
						<label>Type</label>
						<input :disabled="disabled" type="text" v-model="contactCopy.phone_number_1">
						<select :disabled="disabled" v-model="contactCopy.phone_number_1_type_id" @change="updateValue">
							<option value="">Select...</option>
							<option v-for="(phoneNumberType, index) in getPhoneNumberTypes" :value="phoneNumberType.phone_number_type_id">{{ phoneNumberType.description }}</option>
						</select>
					</div>
				</div>
				<div v-if="!addressOnly">
					<div class="two-columns">
						<label>Country</label>
						<label>Birthdate</label>
						<select v-model="contactCopy.country_code" :disabled="disabled" @change="updateValue">
							<option value="US">United States</option>
							<option value="CAN">Canada</option>
							<optgroup label="Other">
								<option v-for="(country, code) in this.COUNTRIES_LIST" :value="code">{{ country }}</option>
							</optgroup>
						</select>
						<input :disabled="disabled" type="date" v-model="contactCopy.birthdate" />
					</div>
					<div v-if="!hideNotes && !disabled" class="two-one-columns">
						<div>
							<label>Note</label>
							<textarea v-model="contactCopy.notes[0]['note']" style="height: 4.75em; margin: 0;" />
							<div v-if="contactCopy.notes[0]['contact_note_id']" class="button neutral inline spaced" @click="addNote()"><i class="fa fa-plus" /></div>
							<div v-if="contactCopy.notes.length > 1" class="button neutral inline spaced" @click="deleteNote(contactCopy.notes[0])"><i class="fa fa-trash" /></div>
							<div v-if="contactCopy.notes.length > 1" class="button neutral inline spaced" @click="showNoteHistory = true"><i class="fa fa-list" /></div>
							<div v-if="contactCopy.contact_id" class="button neutral inline spaced" @click="saveNote(contactCopy.notes[0])">Save Note</div>
						</div>
						<div>
							<label>Note Priority</label>
							<div style="margin: 0.5em 0 0 0.25em; line-height: 1.5em;">
								<div>
									<input type="radio" name="contact_flag" v-model="contactCopy.notes[0]['priority']" value="3" @click="updateValue">
									<i class="fa fa-flag" style="padding: 0 0 0 0.25em; color: red;" />
									<label style="padding: 0 0 0 0.5em;">High</label>
								</div>
								<div>
									<input type="radio" name="contact_flag" v-model="contactCopy.notes[0]['priority']" value="2" @click="updateValue">
									<i class="fa fa-flag" style="padding: 0 0 0 0.25em; color: orange;" />
									<label style="padding: 0 0 0 0.5em;">Med</label>
								</div>
								<div>
									<input type="radio" name="contact_flag" v-model="contactCopy.notes[0]['priority']" value="1" @click="updateValue">
									<i class="fa fa-flag" style="padding: 0 0 0 0.25em; color: green;" />
									<label style="padding: 0 0 0 0.5em;">Low</label>
								</div>
								<div>
									<input type="radio" name="contact_flag" v-model="contactCopy.notes[0]['priority']" value="" @click="updateValue">
									<i class="fa fa-flag" style="padding: 0 0 0 0.25em; color: gray;" />
									<label style="padding: 0 0 0 0.5em;">None</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!addressOnly" style="margin: 0 0 0 1em; height: 100%; overflow-y: scroll;">
			<div v-for="(customField, index) in getCustomFields">
				<label>{{ customField.label }}</label>
				<input :disabled="disabled" type="text" v-model="contactCopy[customField.custom_field]">
			</div>
		</div>
	</div>

	<div v-if="!hideControls" class="controls" style="position: fixed; bottom: 4em; width: 72%; border-top: 1px solid #ccc; padding: 0.5em;">
		<div class="button cancel spaced" @click="$emit('cancel')" v-if="!noCancel"><template v-if="!changed || disabled || $route.query.return"> {{ backToListLabel || 'Back To List' }}</template><template v-else>Cancel</template></div>
		<div :class="['button', 'spaced', { disabled: disabled || !saveable, action: saveable }]" @click="saveContact()">Save</div>
		<transition name="fade"><span class="message" v-if="saveMessage">{{ saveMessage }}</span></transition>
		<transition name="fade"><span class="message" v-if="message">{{ message }}</span></transition>
	</div>

	<div v-if="showNoteHistory" class="modal medium-modal">
		<div class="inner">
			<h2>Notes History</h2>
			<div class="content">
				<div v-for="(note, index) in contactCopy.notes" class="three-columns" style="grid-template-columns: 1fr 5em 4em; margin: 0 0 1em 0;">
					<textarea v-model="note.note" style="width: 30em; height: 4em;" />
					<div>
						<div>
							<input type="radio" :name="'contact_flag_' + index" v-model="note.priority" value="3">
							<i class="fa fa-flag" style="padding: 0 0 0 0.25em; color: red;" />
							<label style="padding: 0 0 0 0.5em;">High</label>
						</div>
						<div>
							<input type="radio" :name="'contact_flag_' + index" v-model="note.priority" value="2">
							<i class="fa fa-flag" style="padding: 0 0 0 0.25em; color: orange;" />
							<label style="padding: 0 0 0 0.5em;">Med</label>
						</div>
						<div>
							<input type="radio" :name="'contact_flag_' + index" v-model="note.priority" value="1">
							<i class="fa fa-flag" style="padding: 0 0 0 0.25em; color: green;" />
							<label style="padding: 0 0 0 0.5em;">Low</label>
						</div>
					</div>
					<div>
						<div class="button neutral inline full-width" style="margin: 0 0 0.5em 0;" @click="saveNote(note)">Save</div>
						<div class="button neutral inline full-width" @click="deleteNote(note)">Delete</div>
					</div>
				</div>
			</div>
			<div class="controls">
				<div class="button neutral" @click="showNoteHistory = false">Cancel</div>
			</div>
		</div>
	</div>

	<message-modal v-if="hideControls && message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" @action="doMessageModalAction()" />

</div>

</template>

<script>
import LabelRequired from '@/components/LabelRequired.vue'
import StateSelect from '@/components/StateSelect.vue'
import DateInput from '@/components/DateInput.vue'
export default {
	name: 'contact-detail-form',
	props: ['clientId', 'contact', 'saveMessage', 'noCancel', 'backToListLabel', 'addressNotRequired', 'emailRequired', 'hideControls', 'hideFFLInputs', 'hideDLInputs', 'hideNotes', 'addressOnly'],
    components: {
        'label-required': LabelRequired,
        'state-select': StateSelect,
		'date-input': DateInput
    },
	data() {
		return {
			contactCopy: {},
			message: '',
			showNoteHistory: false,
			saving: false,
			messageStatus: '',
			messageTimeout: 0
		}
	},
    created() {
		this.checkPhoneNumberTypes()
		this.checkCustomFields()
		this.contactCopy = this.$copy(this.contact)
		if (!this.contactCopy.notes) {
			this.contactCopy.notes = [
				{ note: '', priority: '' }
			]
		}
	},
    watch: {
		contact(newVal) {
			if (newVal) {
				this.contactCopy = this.$copy(this.contact)
			}
		}
	},
	computed: {
    	changed() {
    		return this.$changed(this.contact, this.contactCopy)
    	},
    	disabled() {
			if (this.getAdministratorFlag) { return false }
    		return this.contactCopy.client_id != this.clientId
    	},
    	isProfile() {
	    	return this.$route.path.indexOf('profile') > -1 || true
    	},
		saveable() {
			return this.addressNotRequired || (this.contactCopy.address_1 && this.contactCopy.city && (this.contactCopy.state || this.contactCopy.country_code) && this.contactCopy.zip_code)
		}
    },
	methods: {
        checkPhoneNumberTypes() {
			if (this.getPhoneNumberTypes.length == 0) {
	            this.apiCall({ destination: 'get_list_phone_number_types' })
			}
        },
        checkCustomFields() {
			if (this.getCustomFields.length == 0) {
	            this.apiCall({ destination: 'get_list_custom_fields' })
			}
        },
		updateValue() {
			if (this.hideControls) {
				// slight delay while DOM catches up -- helps with radio button click
	            setTimeout(() => {
					this.$emit('update', this.contactCopy);
	            }, 250)
			}
		},
		saveContact() {
			this.message = ''
			for (let key in this.contactCopy) {
				if (typeof this.contactCopy[key] == 'string') {
					this.contactCopy[key] = this.contactCopy[key].trim()
				}
			}
			if (!(this.contactCopy.first_name && this.contactCopy.last_name) && !this.contactCopy.company_name) {
				this.message = 'First and Last Name or Company Name are required.'
				return false
			}
			if (!this.addressNotRequired && !this.contactCopy.address_1) {
				this.message = 'Address is required.'
				return false
			}
			if (!this.addressNotRequired && !this.contactCopy.city) {
				this.message = 'City is required.'
				return false
			}
			if (!this.addressNotRequired && !this.contactCopy.state) {
				this.message = 'State is required.'
				return false
			}
			if (!this.addressNotRequired && !this.contactCopy.zip_code) {
				this.message = 'Zip Code is required.'
				return false
			}
			if (this.emailRequired && !this.contactCopy.email_address) {
				this.message = 'Email Address is required.'
				return false
			}
			if (this.emailRequired && !this.$isValidEmailAddress(this.contactCopy.email_address)) {
				this.message = 'Email Address is not valid.'
				return false
			}
			this.$emit('save', this.contactCopy)
		},
		updateSelectedState(state) {
			this.contactCopy.state = state
			this.updateValue()
		},
		addNote() {
			this.contactCopy.notes.unshift({ note: '', priority: '' });
		},
		saveNote(note) {
			if (!note.note || this.saving) { return }
			this.message = 'Saving note...'
			this.saving = true
			this.apiCall({ destination: 'save_item_contact_note', data: { contact_id: this.contactCopy.contact_id, contact_note_id: note.contact_note_id, note: note.note, priority: note.priority } }).then(obj => {
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.saving = false
					this.message = 'Note saved!'
					this.messageTimeout = 1500
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		deleteNote(note) {
			if (!note.contact_note_id) { 
				for (let i = 0; i < this.contactCopy.notes.length; i++) {
					if (this.contactCopy.notes[i].contact_note_id == note.contact_note_id) {
						this.contactCopy.notes.splice(i, 1)
						break
					}
				}
				return 
			}
			this.apiCall({ destination: 'delete_item_contact_note', data: { contact_id: this.contactCopy.contact_id, contact_note_id: note.contact_note_id } }).then(obj => {
				if (obj.status == 'success') {
					for (let i = 0; i < this.contactCopy.notes.length; i++) {
						if (this.contactCopy.notes[i].contact_note_id == note.contact_note_id) {
							this.contactCopy.notes.splice(i, 1)
							break
						}
					}
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
